import { CONTENT_PLACEHOLDER } from 'my-purchases/constants/constants'
import { ORDER_STATUS } from 'my-purchases/constants/orderStatus'
import type { PAYMENT_TYPES } from 'my-purchases/constants/paymentTypes'
import type { Order } from 'my-purchases/types/purchaseList'

import { getOrderStatusInfo } from './getOrderStatusInfo'
import { getStatusDescription } from './getStatusDescription'

interface GetSingleOrderStatusProps {
	paymentMethod: PAYMENT_TYPES
	isActive: boolean
	order: Order
}

export function getSingleOrderStatus({
	paymentMethod,
	isActive,
	order,
}: GetSingleOrderStatusProps) {
	const { outOfStockItems, alert, status } = order

	if (!order) {
		return { statusMessage: '' }
	}

	return {
		orderId: order.id,
		statusTitle: status
			? `myPurchases.online.status_${status}.label`
			: CONTENT_PLACEHOLDER,
		...(alert || (outOfStockItems && status === ORDER_STATUS.in_preparation)
			? getOrderStatusInfo({
					isActive,
					order,
					paymentMethod,
				})
			: getStatusDescription({ paymentMethod, isActive, order })),
		screenReaderText: 'accessibility.myPurchases.orderStatus.text',
		isAlert: !!alert,
	}
}
